




















import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TextArea",
  props: {
    invalid: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    rows: {
      type: String,
      default: ""
    },
    cols: {
      type: String,
      default: ""
    },
    fontSize: {
      type: String,
      default: "",
      validator(value: string) {
        return ["", "medium", "large"].includes(value);
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      default: ""
    }
  },
  computed: {
    classes: function() {
      return {
        "textArea--invalid": this.invalid,
        "textArea--size--medium": this.fontSize === "medium",
        "textArea--size--large": this.fontSize === "large"
      };
    }
  },
  methods: {
    updateValue(event: Event) {
      if (event.target instanceof HTMLTextAreaElement) {
        this.$emit("input", event.target.value);
        this.$emit("change", event.target.value);
      }
    },
    focus() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea as HTMLTextAreaElement;
        if (textarea) {
          textarea.focus();
          textarea.selectionStart = 0;
          textarea.selectionEnd = 0;
          textarea.scrollTop = 0;
          return textarea;
        }
      });
    }
  }
});
